export const SET_CART_PRODUCT = "SET_CART_PRODUCT"

export const REMOVE_CART_PRODUCT = "REMOVE_CART_PRODUCT"

export const GET_CART_PRODUCTS = "GET_CART_PRODUCTS"
